import { Observable } from 'rxjs';
import { CrpInterface } from '../models/crp.model';
import { crpInternational } from '../models/crp-body';

export abstract class CrpRepository {
    abstract postCrp(
        crpInternational: crpInternational,
    ): Observable<CrpInterface>;
}
